import { Component, OnInit, Input, Output, EventEmitter, SecurityContext } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { DialogConfig } from '../../dialog/dialog-config';
import { DialogRef } from '../../dialog/dialog-ref';

@Component({
    selector: 'diacom-viewer',
    templateUrl: './diacom-viewer.component.html',
    styleUrls: ['./diacom-viewer.component.scss'],
    standalone: false
})
export class DiacomViewerComponent implements OnInit {
  @Input() config: any = false;
  @Output() documentDetails = new EventEmitter();
  docUrl: any = "";
  currentdata: any = {};

  constructor(
    public baseService: BaseService,
    public appService: AppService,
    public sanitizer: DomSanitizer,
    public route: ActivatedRoute,
    public alerts: AlertsService,
    public loader: LoaderService,
    public dialogConfig?: DialogConfig,
    public dialogref?: DialogRef
  ) { }

  ngOnInit() {
    if (this.config) {
      if (this.config.datasource) {
        this.setUrlByDataSource(this.config.datasource);
      } else if (this.config.url) {
        if(this.config.type)
          this.setUrl(this.config.type, this.config.url);
        else
          this.setUrl("file", this.config.url);
      }
    }
    else if (this.dialogConfig != undefined && this.dialogConfig.data != undefined && this.dialogConfig.data.data != undefined) {
      if (this.dialogConfig.data.config.type == "checkFromRes") {
        let cloneData = JSON.parse(JSON.stringify(this.dialogConfig.data));
        this.setAsPerRes(cloneData, this.dialogConfig.data.data);
      }
    }
    else {
      if (this.route.data != undefined) {
        this.route.data.subscribe(data => {
          if (data.config != undefined && data.config.datasource != undefined && data.config.datasource) {
            //this is for integration from pacs server
            if (data.config.type == "checkFromRes") {
              let cloneData = JSON.parse(JSON.stringify(data));
              this.setAsPerRes(cloneData, JSON.parse(sessionStorage.getItem('currentData')));
            }
            //this will work for the normal cases
            else {
              this.config = data.config;
              this.setUrlByDataSource(this.config.datasource, this.config.type != undefined && this.config.type ? this.config.type : 'file');
            }
          }
        });
      }
    }
    this.currentdata['listener'] = this.config != undefined && this.config && this.config.key != undefined ? this.config.key + 'stateUpdate' : 'stateUpdate';
    document.addEventListener(this.currentdata['listener'], this.handleEvent, false);
  }
  setUrlByDataSource(datasource, type?) {

    var datasourceUrl: any = {};
    datasourceUrl.resource = datasource.resource != undefined ? datasource.resource : "";
    datasourceUrl.application = datasource.application != undefined ? datasource.application : this.appService.getApplication();
    datasourceUrl.queryId = datasource.queryId != undefined ? datasource.queryId : undefined;
    datasourceUrl.args = datasource.args != undefined ? this.baseService.buildDyanamicStr(datasource.args, { data: JSON.parse(sessionStorage.getItem('currentData')) }) : false;

    var url = this.baseService.get_url(datasourceUrl.queryId, datasourceUrl.args, datasourceUrl.resource, datasourceUrl.application);
    var diacomFileType = type;
    this.setUrl(diacomFileType, url);
    console.log("url for dicom is as", this.docUrl);
  }

  setUrl(type, url) {
    this.loader.showSpinner();
    var urlData = url.split("?");
    //check here also
    if (urlData[1] != undefined) {
      var token = this.appService.getXsrfToken(urlData[1], true);
    } else {
      var token = this.appService.getXsrfToken("", true);
    }
    this.baseService.getFileByUrl(url, false).subscribe(res => {
      if (res) {
        let contentType = res.type != undefined ? res.type : "";
        this.docUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.getDiacomUrl() + "?url=" + btoa(url) + "&type=" + type + "&contentType=" + contentType + "&token=" + btoa(token) + (this.config.documentId ? ("&id=" + btoa(this.config.documentId)) : '') + '&listener=' + btoa(this.currentdata['listener']));
      }
      else {
        //do nothing
      }
      this.loader.hideSpinner();
    });
  }

  getDiacomUrl() {
    return "/diacom-viewer/";
  }

  handleEvent = (e) => {
    try {
      console.log('state dicom viewer 76' + e)
      this.documentDetails.emit(e.detail)
      // this.alerts.success('Saved Successfully.')

    } catch (error) {

    }

  }
  ngOnDestroy() {
    localStorage.removeItem('annotationJson');
    document.removeEventListener(this.currentdata['listener'], this.handleEvent)
  }

  async getData(queryId, args, resource, application, filter, callback?) {
    // (queryId, args, resource = null, application?: any, filter?: any, responseType?: any, config?: any)
    let data = {}
    data['args'] = args 
    data['filter'] = filter 
    if(this.dialogConfig?.data?.config?.datasource?.read_scope_level){
      data['read_scope_level'] = 'account'
    }
    await this.baseService.getData(data, "", resource, application, queryId).toPromise().then(data => {
      if (data && data.resource != undefined && data.resource.length != undefined && data.resource.length > 0) {
        if (callback) {
          callback(data.resource);
        }
      }
      else if (callback) {
        callback(false);
      }
    })
  }

  setAsPerRes(data, objData) {
    try {
      let dataSource = data.config.datasource;
      dataSource.args = dataSource.args != undefined ? this.baseService.buildDyanamicStr(dataSource.args, { data: objData }) : "";
      this.loader.showSpinner();
      this.getData(dataSource.queryId, dataSource.args, dataSource.resource, dataSource.application, "", (data) => {
        if (data != undefined && data[0] != undefined && data[0].pacs_image_url != undefined && data[0].pacs_image_url) {
          // let url = JSON.parse(data[0].pacs_image_url);
          let url = data[0].pacs_image_url;
          // window.open(url, '_blank').focus();
          window.open(url, '_blank', "noopener");
          if (this.dialogConfig != undefined && this.dialogConfig.data != undefined && this.dialogConfig.data.data != undefined) {
            this.dialogref.close();
          } else { window.history.back(); }
        }
        else if (data != undefined && data[0] != undefined && data[0].pacs_image_id != undefined && data[0].pacs_image_id) {
          if (data[0].annotated_data != undefined && data[0].annotated_data) {
            localStorage.setItem('annotationJson', data[0].annotated_data);
          }
          let url = this.baseService.getApiEndpoint("dms") + 'emrImage' + '/image-response-entity?args=id:' + data[0].pacs_image_id + '&application=dms';
          this.setUrl("file", url);
        }
        this.loader.hideSpinner();
      });
    } catch (error) {
      console.error(error);
    }

  }


}
